import CardTable from 'components/CardTable/CardTable'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'

import { resetSuccess } from 'redux/actions/tanks/tanksAction'

import { columnsTanksUnits } from './columnsTanksUnits'
import Snackbars from "components/Snackbar/Snackbar.js";
import { resetTankSelected } from 'redux/actions/tanks/tanksAction'
import { resetError } from 'redux/actions/tanks/tanksAction';
import SearchMenuConfigSync from 'components/SearchMenuConfigSync/SearchMenuConfigSync';
import { useColorTheme } from 'hooks/useColorTheme';
import { AssignTank } from './AssignTank';
import { CLOSE_MODAL_ASSIGN } from 'redux/reducers/tanks/tanksReducer';
import { convertToMapById } from 'helpers/convertToMap';
import { getUnitsConfigs, cleanStation, cleanUnitsConfig } from 'redux/actions/unitsSection/unitsAction';
import { ModalV2 } from 'components/Modal/ModalV2'


export const TanksByStationsV2 = () => {
  const colorBg = useSelector((state) => state.config.colorBg);
  const { color, colorRGB } = useColorTheme(colorBg);
  const { companies } = useSelector(state => state.companies)
  const { token } = useSelector(state => state.login)
  const { units, unitsConfig, loading: loadingUnits } = useSelector(state => state.unitsReducer)
  const {  tanks, modalAssingTank, dataSuccess, messageSuccess, error, errorMessage } = useSelector(state => state.tanks)
  const { handleIsOpen } = useOpenComponent()
  const [company, setCompany] = useState('')
  const [stations, setStations] = useState([])
  const [unitsFilter, setUnitsFilter] = useState([])
  const [selectStation, setSelectStation] = useState('')
  const [mapData, setMapData] = useState([]);
  const [mapCompanies, setMapCompanies] = useState([]);
  const dispatch = useDispatch()
  const isModalOpenByDefault = Boolean(modalAssingTank);

  const handleClose = () => {
    dispatch({ type: CLOSE_MODAL_ASSIGN })
    dispatch(resetTankSelected())
  }

  useEffect(() => {
    setMapData(Object.keys(tanks)?.map(id => tanks[id]).filter(tank => units[tank?.id_unit]?.idStation === selectStation && tank.assigned === 0 ).map(item => {
      return {
        ...item,
        label: item.name,
        value: item.id,
        numberLabel: units[item.id_unit] ? units[item.id_unit]?.number : 'Sin Unidad', 
        modal: handleIsOpen 
      } 
    }))
    // eslint-disable-next-line
  }, [selectStation, tanks])
  
  useEffect(() => {
  company && setStations( companies[company]?.stations )
}, [company, companies])

  const handleCleanError = () => {
    dispatch(resetError())
  }

  const handleSelectCompany = ({ target }) => {
    setUnitsFilter([])
    const {value} = target
    setCompany(value)
  }
  
  const handleSelectStation = (e) => {
    const {value} = e.target
    setSelectStation(value)
    dispatch(getUnitsConfigs(value, token))
  }

  useEffect(() => {
    return () => {
      dispatch(cleanStation());
      dispatch(cleanUnitsConfig());
    }
  }, [dispatch])

  const getStationaryUnits = unitsConfig => Object.keys(unitsConfig).filter(id => unitsConfig[id].type === 'ESTACIONARIO');

  useEffect(() => {
    setMapCompanies(convertToMapById(companies) )
    const units = selectStation
      ? getStationaryUnits(unitsConfig).map(unit => ({...unitsConfig[unit],id_station_temp: selectStation }))
      : [];

    setUnitsFilter(units)
  }, [selectStation, unitsConfig, companies])

  return (
    <React.Fragment>
      <SearchMenuConfigSync
        color={color}
        colorRGB={colorRGB}
        companies={mapCompanies}
        stations={stations}
        companySelect={company}
        stationSelect={selectStation}
        blockUnitType={false}
        onCompanySelect={handleSelectCompany}
        onStationSelect={handleSelectStation}
      />
      <CardTable
        data={unitsFilter}
        columns={columnsTanksUnits}
        loading={ loadingUnits }
        previousText="Anterior"
        nextText="Siguiente"
        noDataText="Sin datos"
        pageText="Pagina"
        ofText="de"
        rowsText="Tanques"
      />
      <ModalV2
        open={isModalOpenByDefault}
        onClose={handleClose}
        toRight
        title={'Asignar tanque(s) a unidad'}
        >
          <AssignTank data={mapData} close={handleClose} station={selectStation}></AssignTank>
      </ModalV2>


      <Snackbars
        place="tr"
        color="success"
        message={messageSuccess}
        open={dataSuccess}
        closeNotification={() => dispatch(resetSuccess())}
        close
      /> 
      <Snackbars
        place="tr"
        color="danger"
        message={errorMessage}
        open={error}
        closeNotification={handleCleanError}
        close
      /> 
    </React.Fragment>
  )
}
